import React from 'react';
import d3 from 'd3';

/*export default class HighlightPoints extends React.Component {
    render() {
        
        let xcoords = this.props.dataseries.series.map((val) => this.props.xScale(val[0]));
        let innerspacings = xcoords.reduce((prev,cur,i,arr) => {
            if(i>0) {
                prev.push(Math.min((arr[i]-arr[i-1])/2,this.props.closeness));
            }
            return prev;
        },[]);
        let spacings = [this.props.closeness,...innerspacings,this.props.closeness];
        
       
        return <g ref="scattergroup">
            {
                this.props.dataseries.series.map(
                    (point,i) => {
                        let shown;
                        let distance = this.context.mouseX - this.props.xScale(point[0]);
                        if(distance > 0) {
                            shown = Math.abs(distance) < spacings[i+1];
                        } else {
                            shown = Math.abs(distance) < spacings[i];
                        }
                        
                        
                        return <circle 
                            key={"circle_"+i} 
                            r={this.props.radius} 
                            cx={this.props.xScale(point[0])} 
                            cy={this.props.yScale(point[1])}
                            style={{
                                visibility: shown?'visible':'hidden' 
                            }}
                            />
                    }
                )
            }
        </g>
    }
}

HighlightPoints.contextTypes = {
    mouseX: React.PropTypes.number,
    mouseY: React.PropTypes.number
};*/
const getHighlightArray = function(props,context) {
    let coordarr = props.data.map((dataobj) => {
        if(!context.mouseX || !context.mouseY) { return null; }
        let xcoords = dataobj.series.map((val) => props.xScale(val[0]));
        let innerspacings = xcoords.reduce((prev,cur,i,arr) => {
            if(i>0) {
                prev.push(Math.min((arr[i]-arr[i-1])/2,props.closeness));
            }
            return prev;
        },[]);
        let spacings = [props.closeness,...innerspacings,props.closeness];    
        let minindex = 0;
        let distances = xcoords.map((val) => val - context.mouseX);
        for(let i=0;i<distances.length;i++) {
            if(Math.abs(distances[i]) < Math.abs(distances[minindex])) {
                minindex = i;
            }
        }
        if((distances[minindex]>=0 && Math.abs(distances[minindex])<spacings[minindex]) || 
            (distances[minindex]<0 && Math.abs(distances[minindex])<spacings[minindex+1])) {
            let pointdistance = distances[minindex]>=0?Math.abs(distances[minindex]):Math.abs(distances[minindex]);
            
            return {
                name: dataobj.name,
                xval: dataobj.series[minindex][0],
                yval: dataobj.series[minindex][1],
                pointdistance: pointdistance,
                color: dataobj.color
            }
        }
        return null;
    });
    coordarr = coordarr.filter((v) => v!=null);
    if(coordarr.length>0) {
        let closestx = coordarr.reduce((prev,cur) => (!prev||cur.pointdistance<prev.pointdistance)?cur:prev).xval;
        coordarr = coordarr.filter((v) => 
            JSON.stringify(v.xval)==JSON.stringify(closestx)
        );
    }
    return coordarr;
}
export default class HighlightPoints extends React.Component {
    componentDidUpdate(oldprops,oldstate,oldcontext) {
        let oldcoordarr = getHighlightArray(oldprops,oldcontext);
        let coordarr = getHighlightArray(this.props,this.context);
        if(this.props.onHighlight && JSON.stringify(coordarr) !== JSON.stringify(oldcoordarr)) {
            this.props.onHighlight(coordarr.length>0?coordarr:null);
        }
    }
    render() {
        let coordarr = getHighlightArray(this.props,this.context);
        return <g>
            {
                coordarr.map((coordobj,i) =>  <circle 
                    key={"circle_"+i} 
                    r={this.props.radius || 5} 
                    cx={this.props.xScale(coordobj.xval)} 
                    cy={this.props.yScale(coordobj.yval)}
                    fill = {this.props.useSeriesColor?coordobj.color:null}
                    />
                )
            }
        </g>
    }
}

HighlightPoints.contextTypes = {
    mouseX: React.PropTypes.number,
    mouseY: React.PropTypes.number
};


// WEBPACK FOOTER //
// ./src/js/components/charting/HighlightPoints/HighlightPoints.jsx